import React from 'react';
import './Header.css';
import logo from './rn_logo.jpg';
import Dropdown from '../Dropdown/Dropdown';

const Header = ({ langOptions, lang }) => (
	<div className="site-header row">
		<div className="container">
			<a href="https://www.researchnow.com/"><img src={logo} /></a>
			<Dropdown
				options={langOptions}
				lang={lang}
			/>
		</div>
	</div>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js